import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import Filter, { FilterModal, FilterSection } from './Filter';
import CheckboxFilterByType from './FilterComponents/CheckboxFilterByType';

import styles from '../search.scss';

const SportTypeFilter = (props) => {
    const {
        clearFilters,
        filters,
        filterInputs,
        handleFilterClick,
        filterModal,
        closeModals,
        searchTypes,
        handleFilterSubmit,
        handleFilterUpdate,
        mobileOnly,
        desktopOnly,
        'data-testid': dataTestId,
    } = props;
    useEffect(() => {
        if (!!filterInputs?.sportTypes?.pickleball && !!filterInputs?.sportTypes?.tennis) {
            handleFilterUpdate({
                utrTeamType: 'singles',
                utrMin: 1,
                utrMax: 16,
            });
        } else if (!!filterInputs?.sportTypes?.pickleball) {
            handleFilterUpdate({
                utrTeamType: 'doubles',
                utrMin: 1,
                utrMax: 10,
            });
        } else {
            handleFilterUpdate({
                utrTeamType: 'singles',
                utrMin: 1,
                utrMax: 16,
            });
        }
    }, [filterInputs?.sportTypes?.pickleball, filterInputs?.sportTypes?.tennis, filterInputs?.type]);

    const handleCheckboxChange = (value) => {
        const currentFilters = filterInputs.sportTypes;
        const isDeselecting = currentFilters[value];
        const selectedCount = Object.values(currentFilters).filter(val => val).length;

        if (isDeselecting && selectedCount === 1) {
            return;
        }

        handleFilterUpdate({
            sportTypes: {
                ...currentFilters,
                [value]: !currentFilters[value],
            },
        });
    };

    const sportTypeLabelTennis = 'Tennis';
    const sportTypeLabelPickleball = 'Pickleball';
    const sportLabel = 'Sport';
    let sportTypeLabel;

    if (!!filters?.sportTypes?.tennis && !!filters?.sportTypes?.pickleball) {
        sportTypeLabel = sportLabel;
    } else if (!!filters?.sportTypes?.tennis) {
        sportTypeLabel = sportTypeLabelTennis;
    } else {
        sportTypeLabel = sportTypeLabelPickleball;
    }

    return (
        <div className={styles.filterWrapper}>
            <Filter
                filterName={'sportType'}
                handleFilterClick={handleFilterClick}
                isActive={(filters && filters.sportTypes && Object.values(filters.sportTypes).indexOf(true) > -1) || filterModal === 'sportType'}
                mobileOnly={mobileOnly}
                desktopOnly={desktopOnly}
                data-testid={dataTestId}
            >
                {sportTypeLabel}
            </Filter>
            {filterModal === 'sportType' && (
                <FilterModal
                    title={'Sport Type'}
                    handleFilterSubmit={handleFilterSubmit}
                    onCloseClick={closeModals}
                    clearFilters={() => clearFilters('sportType')}
                    data-testid={dataTestId}
                >
                    <FilterSection>
                        <CheckboxFilterByType
                            searchTypes={searchTypes}
                            searchTypesPropName={`sportTypes`}
                            filterInputs={filterInputs}
                            filtersPropName={`sportTypes`}
                            onChange={handleCheckboxChange}
                            data-testid={dataTestId && `${dataTestId}.options`}
                        />
                    </FilterSection>
                </FilterModal>
            )}
        </div>
    );
};
SportTypeFilter.propTypes = {
    filterInputs: PropTypes.instanceOf(Object),
    filters: PropTypes.instanceOf(Object),
    'data-testid': PropTypes.string,
};
SportTypeFilter.defaultProps = {
    filterInputs: {},
    filters: {},
    'data-testid': undefined,
};

export default SportTypeFilter;
